"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _portals = require("@mulesoft/exchange-ui-portals-store/lib/domains/portals");
var _reactRedux = require("react-redux");
var _EditMode = _interopRequireDefault(require("../EditMode"));
var _ViewMode = _interopRequireDefault(require("../ViewMode"));
var DraftHeader = function DraftHeader(_ref) {
  var isPageComponent = _ref.isPageComponent,
    hasUnpublishedChanges = _ref.hasUnpublishedChanges;
  var isEdit = (0, _exchangeReactHooks.useIsPortalEdit)();
  var isDraft = (0, _exchangeReactHooks.useIsPortalDraft)();
  var isLoading = (0, _reactRedux.useSelector)(_portals.selectors.isPortalLoading);
  if (!isDraft) {
    return null;
  }
  if (isEdit) {
    return /*#__PURE__*/_react.default.createElement(_EditMode.default, {
      isLoading: isLoading,
      hasUnpublishedChanges: hasUnpublishedChanges
    });
  }
  return /*#__PURE__*/_react.default.createElement(_ViewMode.default, {
    isLoading: isLoading,
    isPageComponent: isPageComponent
  });
};
var _default = exports.default = DraftHeader;
//# sourceMappingURL=DraftHeaderLayout.js.map